// extracted by mini-css-extract-plugin
export default {"desktop":"Desktop_desktop__VutlL","instructionContainer":"Desktop_instructionContainer__kHmba","instruction":"Desktop_instruction__EZniV"};